var exports = {
  "Q": "xe7b6e3d6--2b1236--content",
};

module.exports = exports;
